import {makeAutoObservable, configure, runInAction} from 'mobx';
import {db} from "../firebase/Firebase";
import {buttonSuccess} from "../utils/ComponentsSetting";

const data = {
    providerPercentage: null,
    cardPayment: false,
    tripStartControl: 60,
    paymentGatewayCommission: null,
    transaction: null,
    IVA: null,
    maximumTimeReservation: null,
    maximumCancellationTime: null,
    vehicleDisplay: ''
}


configure({
    enforceActions: 'never',
})

class DataStore {
    companyName = '';
    idCompany = '';
    contactNumbers = '';
    userUid = '';
    role = ''
    userName = ''
    companyMail = '';
    userMail = '';
    imageAsUrl = null
    usersPermissions = []
    openDrawer = true;
    finished = false
    providerPercentage = null
    vehicleDisplay = null
    tripStartControl = null
    bookingAnticipation = null
    tabs = null
    restrictZones = null
    dataPassengers = null
    mainViewport = null
    details = null
    triggerEffect = false
    generalValues = null

    constructor() {
        makeAutoObservable(this);
    }

    getCompanyData(name, id, role, companyMail, userMail, userUid, userName) {
        this.companyName = name
        this.idCompany = id
        this.role = role
        this.companyMail = companyMail
        this.userMail = userMail
        this.userUid = userUid
        this.userName = userName
    }

    getImageAsUrl = (image) => {
        this.imageAsUrl = image;
    }

    getUsersPermissions = (permissions) => {
        this.usersPermissions = permissions;
    }

    getValueOpenDrawer = (value) => {
        this.openDrawer = value;
    };

    getCompanyDataInfo = (status) => {
        this.finished = status;
    }

    getRestrictZones = (zones) => {
        this.restrictZones = zones
    }

    getGeneralValues = (providerPercentage, tripStartControl, bookingAnticipation, vehicleDisplay) => {
        this.providerPercentage = providerPercentage
        this.tripStartControl = tripStartControl
        this.bookingAnticipation = bookingAnticipation
        this.vehicleDisplay = vehicleDisplay
    }

    getCompanyNumbers = (contactNumbers) => {
        this.contactNumbers = contactNumbers
    }

    getTabs = (tabs) => {
        this.tabs = tabs
    }

    getDataPassengers = (data) => {
        this.dataPassengers = data
    }

    getViewPort = (viewport) => {
        this.mainViewport = viewport
    }

    getPaymentsDetails = (details) => {
        this.details = details
    }

    getTriggerEffect = (triggerEffect) => {
        this.triggerEffect = triggerEffect
    }

    GeneralValues = async (companyName, idCompany)=>{
        const docRef = db.collection(companyName).doc(idCompany).collection('GeneralValues')
        await docRef.doc(idCompany).get()
            .then(doc => {
                if (doc.exists) {
                    runInAction(() => {
                        this.generalValues=  {...doc.data(), docId: doc.id}
                    })
                } else {

                    runInAction(() => {
                        this.generalValues=  {...data}
                    })
                }
            })
    }
}

const dataStore = new DataStore();

export default dataStore

